module.exports = __webpack_public_path__ + "static/img/作品23.4255688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品23.png
// module id = fqvP
// module chunks = 1